import { useSelector } from 'react-redux';
import { selectCurrentMember } from '../../../services/store/modules/backend-service';
import useIsDesktop from '../../hooks/use-is-desktop';

interface DesktopSidebarState {
  /** The sidebar is on screen: desktop width and a signed-in member */
  visible: boolean;
  /**
   * The sidebar can be used. Focused map flows (logging a trip on, measuring
   * distance, choosing a point, float plan steps) hide map navigation, so the
   * sidebar is disabled while they're open.
   */
  enabled: boolean;
}

const useDesktopSidebar = (): DesktopSidebarState => {
  const isDesktop = useIsDesktop();
  const member = useSelector(selectCurrentMember);
  const showingControlPaneMenu = useSelector(
    (state: { appControls?: { showingControlPaneMenu?: boolean } }) =>
      state.appControls?.showingControlPaneMenu,
  );

  return {
    visible: isDesktop && Boolean(member),
    enabled: showingControlPaneMenu !== false,
  };
};

export default useDesktopSidebar;
